// Cómo terminó una atención de recepción: el motivo por el que no avanzó y la
// clasificación del resultado.
//
// Los dos datos salen hoy de catálogos editables en Administración > Datos Maestros
// (tablas motivo_rechazo y resultado_atencion) y el turno guarda el nombre de la fila
// elegida tal cual. Lo que queda acá son las funciones de etiqueta, más la lista
// histórica de códigos de motivo que sobrevive solo para leer turnos viejos.

// Explica por qué el cliente no avanzó con el trámite. Se completa al finalizar la
// atención; el placeholder "Sin especificar" no vive acá porque es propio de cada select.
export const MOTIVOS_NO_AVANCE = [
    { valor: 'FALTA_DOCUMENTACION', etiqueta: 'Falta documentación' },
    { valor: 'NO_PUEDE_PAGAR_MORATORIA', etiqueta: 'No puede pagar moratoria' },
    { valor: 'SOLO_CONSULTA', etiqueta: 'Solo consulta' },
    { valor: 'FALTA_REGULARIDAD_APORTES', etiqueta: 'Falta regularidad / aportes' },
    { valor: 'AUTONOMO_MONOTRIBUTO_DEUDA', etiqueta: 'Autónomo/Monotributo con deuda' },
    { valor: 'NO_TIENE_EDAD', etiqueta: 'No tiene edad' },
    { valor: 'NO_CUMPLE_REQ_DIFERENCIAL', etiqueta: 'No cumple requisito diferencial' },
    { valor: 'NO_POSEE_PORC_INCAPACITANTE', etiqueta: 'No posee porcentaje incapacitante' },
    { valor: 'FALTA_CMO_DICTAMEN', etiqueta: 'Falta CMO / dictamen' },
    { valor: 'NO_ACEPTA_PLAN_PAGOS', etiqueta: 'No acepta plan de pagos' },
    { valor: 'HONORARIOS_ELEVADOS', etiqueta: 'Honorarios elevados' },
    { valor: 'DECIDE_CONSULTAR_LUEGO', etiqueta: 'Decide consultar luego' },
    { valor: 'HABER_BAJO', etiqueta: 'Haber bajo' },
    { valor: 'FALTA_EXPEDIENTE', etiqueta: 'Falta expediente' },
    { valor: 'YA_POSEE_ABOGADO', etiqueta: 'Ya posee abogado' },
    { valor: 'EVALUARA_MAS_ADELANTE', etiqueta: 'Evaluará más adelante' },
    { valor: 'NO_CUMPLE_REQUISITOS', etiqueta: 'No cumple los requisitos' },
    { valor: 'NO_TIENE_CLAVES', etiqueta: 'No tiene claves' },
    { valor: 'OTRO', etiqueta: 'Otro' },
];

export function etiquetaMotivoNoAvance(valor) {
    if (!valor) return '';
    const motivo = MOTIVOS_NO_AVANCE.find((m) => m.valor === String(valor).trim().toUpperCase());
    return motivo ? motivo.etiqueta : valor;
}

// Clasifica en qué terminó la atención, independientemente del motivo de no avance.
//
// Desde la migración V224 esto dejó de ser un enum fijo: es un catálogo editable desde
// Administración > Datos Maestros > Resultados de la Atención (tabla resultado_atencion,
// ver GestionResultadosAtencion), y el turno guarda el NOMBRE de la fila elegida tal cual
// — mismo criterio que motivo_no_avance. Por eso ya no hay una lista hardcodeada acá:
// quien necesite las opciones las pide con DatosMaestrosService.getResultadosAtencion().
//
// La función se conserva porque el valor guardado ya ES la etiqueta, y así los lugares que
// muestran el resultado no tienen que saber de dónde salió.
export function etiquetaResultadoAtencion(valor) {
    if (!valor) return '';
    return String(valor);
}
